// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_OXm","cls2":"PaperImages-cls2_k2P PaperImages-cls1_OXm"};